import { render, staticRenderFns } from "./InventoryListView.vue?vue&type=template&id=971887c8&scoped=true"
import script from "./InventoryListView.vue?vue&type=script&lang=js"
export * from "./InventoryListView.vue?vue&type=script&lang=js"
import style0 from "./InventoryListView.vue?vue&type=style&index=0&id=971887c8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971887c8",
  null
  
)

export default component.exports